import { render, staticRenderFns } from "./zb-withdrawal.vue?vue&type=template&id=1386326c&scoped=true&"
import script from "./zb-withdrawal.vue?vue&type=script&lang=js&"
export * from "./zb-withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./zb-withdrawal.vue?vue&type=style&index=0&id=1386326c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386326c",
  null
  
)

export default component.exports